import React from "react";
import { Card } from "antd";

import ReportGenericChart, { getSplitRatio } from "../generics";

import ProgressChart from "./CounselingProgressChart";
import PlatformChart from "./CounselingPlatformChart";
import VisitFeedback from "./VisitFeedback";

import { Metrics } from "../../../theme";
import { GraphDataMaker } from "../../../util/helper/graph";

const PreviewChart = ({typeKey, object, height})=>(
	<Card style={{height:height+75, 
		marginTop:Metrics
	}}>
		<h1>{typeKey}</h1>
		<div>{JSON.stringify(object)}</div>
	</Card>
);

export const CounselingChart = { 
	ProgressChart, 

	VisitFeedback, 
	ReturningChart:     ReportGenericChart.ReportReturningChart, 
	PlatformChart,

	CatgoryChart:       ReportGenericChart.ReportCatgoryChart,
	PieChart:           ReportGenericChart.ReportPieChart,
	ColumnChart:        ReportGenericChart.ReportColumnChart,
	PieObjectChart:     ReportGenericChart.ReportPieObjectChart,
	ColumnObjectChart:  ReportGenericChart.ReportColumnObjectChart,

	PreviewChart
};


// WEBPACK FOOTER //
// ./src/components/report/counseling/index.js